import * as React from "react";
import { FC } from "react";
import { isUnnamed, Resource } from "~/sharedComponents/select/multiSelect/userSelect/types";
import { ResourceGroup } from "~/sharedComponents/select/multiSelect/userSelect/UserGroups";
import { VirtListRowProps } from "../list/BaseList";
import { ListGroupTitle } from "../list/ListGroups/ListGroupTitle";
import { JobRoleListRow } from "./JobRoleListRow";
import { TeamListRow } from "./TeamListRow";
import { UnnamedResourceListRow } from "./UnnamedResourceListRow";
import { UserListRow } from "./UserListRow";

export interface ResourcesListRowProps<T> extends VirtListRowProps<T> {
    isSelected?: boolean;
    className?: string;
}

type ResourceRowComponentType<I> = FC<ResourcesListRowProps<I>>;

export const ResourceGroupRow: ResourceRowComponentType<ResourceGroup> = ({ item, className }) => (
    <ListGroupTitle title={item.Name} className={className} />
);

type ResourceListRow = ResourceRowComponentType<Resource> & { rowHeight: number };
export const ResourceListRow: ResourceListRow = props => {
    if (!!props.item.Users) {
        return <TeamListRow {...props} />;
    }

    if (isUnnamed(props.item)) {
        return <UnnamedResourceListRow {...props} />;
    }

    if (!props.item.UserId && props.item.JobRoleId) {
        return <JobRoleListRow {...props} />;
    }

    return props.item.group ? <ResourceGroupRow {...props} /> : <UserListRow {...props} />;
};

ResourceListRow.rowHeight = UserListRow.rowHeight;
